import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ViewAllContent from '../components/pages/waiting-area/view-all/content';
import NotFoundPage from './NotFoundPage.js';

const WaitingAreaPage = (props) => {
  const dispatch = useDispatch();

  const redirectToPageNotFound = useSelector((state) => state.sharedReducer.redirectToPageNotFound);
  const hasWaitingAreas = useSelector((state) => state.usersReducer.userProfile.hasWaitingAreas);
  const waitingAreasInitiallyLoaded = useSelector((state) => state.waitingAreaReducer.waitingAreasInitiallyLoaded);
  const updateSearchColumn = useSelector((state) => state.sharedReducer.updateSearchColumn);

  let divStyle = {
    zoom: props.zoom || 1,
  };

  return (redirectToPageNotFound || !hasWaitingAreas) && !props.noHeader ? (
    <NotFoundPage dispatch={dispatch} />
  ) : (
    <div style={divStyle}>
      <ViewAllContent
        isInQuicKView={props.isInQuicKView}
        loggedInUserHandler={props.loggedInUserHandler}
        noHeader={props.noHeader}
        waitingAreasInitiallyLoaded={waitingAreasInitiallyLoaded}
        updateSearchColumn={updateSearchColumn}
      />
    </div>
  );
};

export default WaitingAreaPage;
